import { ColorUtility } from './color.utility';
import { SystemQuoteStatus } from '../entities/quotes/system.quote.status';
import { QuoteStatus } from '../entities/quotes/quote.status';

export interface HasSystemQuoteStatus {
  systemStatus: SystemQuoteStatus;
}

export class QuoteStatusUtility {
  public static getColor(status: HasSystemQuoteStatus): string {
    if (!status) return 'transparent';

    return this.getSystemColor(status.systemStatus);
  }

  public static getSystemColor(status: SystemQuoteStatus): string {
    if (!status) return 'transparent';

    switch (status) {
      case SystemQuoteStatus.Open:
        return '#58c43a'; // '#ec3324';

      case SystemQuoteStatus.InProgress:
        return '#f29d39';

      case SystemQuoteStatus.Closed:
        return '#fffe55'; // '#58c43a';
    }
  }

  public static getTextColor(status: QuoteStatus): string {
    const color = this.getColor(status);
    return ColorUtility.idealTextColor(color);
  }

  public static getSortOrder(status: HasSystemQuoteStatus): number {
    if (!status) return 0;

    switch (status.systemStatus) {
      case SystemQuoteStatus.Open:
        return 1000;

      case SystemQuoteStatus.InProgress:
        return 2000;

      case SystemQuoteStatus.Closed:
        return 3000;
    }
  }

  public static getAll(): string[] {
    return [
      SystemQuoteStatus.Open,
      SystemQuoteStatus.InProgress,
      SystemQuoteStatus.Closed
    ];
  }

  public static getAllSystem(excludeClosed = true): string[] {
    const items = [SystemQuoteStatus.Open, SystemQuoteStatus.InProgress];

    if (!excludeClosed) items.push(SystemQuoteStatus.Closed);

    return items;
  }
}
